import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
}

export default function useDashboardAgeAndGender({enabled, filter, start, end}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_AGE_AND_GENDER, filter, enabled, start, end],
    queryFn: async () => (await api.reports.getAgeAndGenderDetections({filter, start, end})).data.data,
  })

  return query
}
